export const mixpanelEvents = {
    // Timer Events
    CANDIDATE_TIMER_HIDE: 'candidate_timer_hide',
    CANDIDATE_TIMER_UNHIDE: 'candidate_timer_unhide',
    // Instruction Events
    CANDIDATE_INSTRUCTION_PAGE_LANDED: 'candidate_instruction_page_landed',
    INSTRUCTIONS_CANDIDATE_CLICK_GET_STARTED: 'instructions_candidate_click_get_started',
    INSTRUCTIONS_CANDIDATE_CLICK_TERMS_CONDITIONS: 'instructions_candidate_click_terms_conditions',
    INSTRUCTIONS_CANDIDATE_CLICK_PRIVACY_POLICY: 'instructions_candidate_click_privacy_policy',
    // Authentication and Login Events
    CANDIDATE_LOGIN_SOCIAL_MEDIA_INITIATED: 'candidate_login_social_media_initiated',
    CANDIDATE_LOGIN_SOCIAL_MEDIA_SUCCESS: 'candidate_login_social_media_success',
    CANDIDATE_LOGIN_OTP_REQUESTED: 'candidate_login_otp_requested',
    CANDIDATE_LOGIN_SOCIAL_MEDIA_LOGIN_FAILED: 'candidate_login_social_media_login_failed',
    CANDIDATE_LOGIN_OTP_FILLED_LOGIN_SUCCESS: 'candidate_login_otp_filled_login_success',
    CANDIDATE_AUTHENTICATED: 'candidate_authenticated',
    CANDIDATE_LOGIN_CLICK: 'candidate_login_click',
    CANDIDATE_REGISTRATION_CONTINUE: 'candidate_registration_continue',
    // Assessment and Answer Events
    CANDIDATE_START_ASSESSMENT_LOADED: 'candidate_start_assessment_loaded',
    CANDIDATE_ASSESSMENT_SUBMITTED: 'candidate_assessment_submitted',
    CANDIDATE_ANSWER_SELECTED: 'candidate_answer_selected',
    CANDIDATE_NEXT_QUESTION_CLICKED: 'candidate_next_question_clicked',
    ASSESSMENT_CANDIDATE_REPORT_QUESTION: 'assessment_candidate_report_question',
    CANDIDATE_SCORE_PAGE_LOAD: 'candidate_score_page_load',
    CANDIDATE_SCORE_GENERATED: 'candidate_score_generated',
    CANDIDATE_SCORE_PAGE_NEXT_CLICKED: 'candidate_score_page_next_clicked',
    CANDIDATE_INSTRUCTION_PAGE_PROCEED: 'candidate_instruction_page_proceed',
    CANDIDATE_ASSESSMENT_IFRAME_LOADED: 'candidate_assessment_iframe_loaded',
    CANDIDATE_ASSESSMENT_IFRAME_LOAD_FAILED: 'candidate_assessment_iframe_load_failed',
    CX_IVY_AUDIO_NOISE_CANCELLATION_ENABLED: 'cx_ivy_audio_noise_cancellation_enabled',
    CX_IVY_AUDIO_NOISE_CANCELLATION_FAILED: 'cx_ivy_audio_noise_cancellation_failed',
    CX_IVY_PARTICIPANT_LEFT: 'ivy_participant_left',
    CX_IVY_PARTICIPANT_JOINED: 'ivy_participant_joined',
    IVY_REPORT_CONFIG_VISUAL_CUES_DISABLED: 'ivy_report_config_visual_cues_disabled',
    IVY_REPORT_CONFIG_SCORES_DISABLED: 'ivy_report_config_scores_disabled',
    CANDIDATE_INSTRUCTION_WALKTHROUGH_STARTED_WITHOUT_SKIP: 'candidate_instruction_walkthrough_started_without_skip',
    CANDIDATE_INSTRUCTION_WALKTHROUGH_STARTED_WITH_SKIP: 'candidate_instruction_walkthrough_started_with_skip',
    CANDIDATE_VIEW_EXTENDED_DURATION: 'candidate_view_extended_duration',
    CX_STEP_WINDOW_EARLY_JOIN_BLOCKED: 'cx_step_window_early_join_blocked',
    CX_STEP_WINDOW_ONBOARDING_ALLOWED: 'cx_step_window_onboarding_allowed',
    CX_STEP_WINDOW_ACTION_WAITING_SCREEN_SHOWN: 'cx_step_window_action_waiting_screen_shown',
    CX_STEP_WINDOW_AUTO_REDIRECTED_TO_EXAM: 'cx_step_window_auto_redirected_to_exam',
    CX_STEP_WINDOW_ACTION_ALLOWED: 'cx_step_window_action_allowed',
    CX_STEP_WINDOW_ONBOARDING_FALLBACK_TO_ACTION: 'cx_step_window_onboarding_fallback_to_action',
    CX_STEP_WINDOW_LATE_ONBOARDING_ALLOWED: 'cx_step_window_late_onboarding_allowed',
    CX_STEP_WINDOW_API_ERROR: 'cx_step_window_api_error',
    CX_STEP_WINDOW_NO_RESTRICTION_FLOW: 'cx_step_window_no_restriction_flow',
    // Async Events
    STOP_RECORDING_CLICK: 'candidate_async_stop_recording_click',
    NEXT_ASYNC_QUESTION_CLICK: 'candidate_async_next_question_click',
    START_RECORDING_CLICK: 'candidate_async_start_recording_click',
    CANDIDATE_ASYNC_PERMISSION_ALLOWED: 'candidate_async_permission_allowed',
    CANDIDATE_ASYNC_TOGGLE_PREVIEW_CLICK: 'candidate_async_toggle_preview_click',
    CANDIDATE_ASYNC_PRACTICE_SCREEN_VIEWED: 'candidate_async_practice_screen_viewed',
    CANDIDATE_ASYNC_PERMISSION_REQUESTED: 'candidate_async_permission_requested',
    CANDIDATE_ASYNC_DEVICE_ACCESS_FAILED: 'candidate_async_device_access_failed',
    CANDIDATE_ASYNC_HW_CHECK_COMPLETE: 'candidate_async_hw_check_complete',
    CX_ASYNC_SKIP_CTA_CLICKED: 'cx_async_skip_cta_clicked',
    CX_ASYNC_SKIP_MODAL_VIEWED: 'cx_async_skip_modal_viewed',
    CX_ASYNC_SKIP_MODAL_CANCELLED: 'cx_async_skip_modal_cancelled',
    CX_ASYNC_SKIP_CONFIRMED: 'cx_async_skip_confirmed',
    CX_ASYNC_ASSESSMENT_RESUME_ATTEMPTED: 'cx_async_assessment_resume_attempted',
    CX_ASYNC_ASSESSMENT_RESUMED: 'cx_async_assessment_resumed',
    CX_ASYNC_ASSESSMENT_RESUME_FAILED: 'cx_async_assessment_resume_failed',
    CX_ASYNC_TIMER_RESUMED: 'cx_async_timer_resumed',
    // Payment Events
    CANDIDATE_PAYMENT_PROCEED: 'candidate_payment_proceed',
    CANDIDATE_COUPON_CODE_APPLY: 'candidate_coupon_code_apply',
    CANDIDATE_EXIT_URL_PROCEED_CLICK: 'candidate_exit_url_proceed_click',
    CANDIDATE_BOOK_PAY_PROCEED: 'candidate_book_pay_proceed',
    CANDIDATE_RESCHEDULE_FEE_PROCEED: 'candidate_reschedule_fee_proceed',
    CANDIDATE_BOOKING_CONFIRM_RESCHEDULE_CLICK: 'candidate_booking_confirm_reschedule_click',
    CANDIDATE_PAY_BOOK_PAGE_SCHEDULE_NOW: 'candidate_pay_book_page_schedule_now',
    CANDIDATE_BOOK_PAY_COMPLETED: 'candidate_book_pay_completed',
    // Payment Refactor events
    CANDIDATE_BOOK_PAY_COMPLETED_REFACTOR: 'candidate_book_pay_completed_refactor',
    CANDIDATE_BOOK_PAY_PROCEED_REFACTOR: 'candidate_book_pay_proceed_refactor',
    // Invoice Events
    CANDIDATE_INVOICE_PAGE_LANDED: 'candidate_invoice_page_landed',
    // Scheduling and Slot Events
    CANDIDATE_SLOT_BOOKING_CONFIRM: 'candidate_slot_booking_confirm',
    CANDIDATE_SCHEDULE_CLICK: 'candidate_schedule_click',
    CANDIDATE_SLOT_BOOKING_PAGE_LANDED: 'candidate_slot_booking_page_landed',
    CANDIDATE_SLOT_CONFIRMED: 'candidate_slot_confirmed',
    CANDIDATE_SLOT_RESCHEDULED: 'candidate_slot_rescheduled',
    CANDIDATE_EARLY_BIRD_PAGE_LANDED: 'candidate_early_bird_page_landed',
    CANDIDATE_RSVP_ACCEPT_PROPOSED_TIME: 'candidate_rsvp_accept_proposed_time',
    CANDIDATE_RSVP_DECLINE_PROPOSED_TIME: 'candidate_rsvp_decline_proposed_time',
    CANDIDATE_RSVP_PROPOSE_ALTERNATIVE_TIME: 'candidate_rsvp_propose_alternate_time',
    CANDIDATE_INTERVIEW_EARLY_BIRD_PAGE_LANDED: 'candidate_interview_early_bird_page_landed',
    CANDIDATE_INTERVIEW_JOIN: 'candidate_interview_join',
    CANDIDATE_PAID_NOT_BOOKED_SCHEDULE_NOW: 'candidate_paid_not_booked_schedule_now',
    CANDIDATE_PAY_BOOK_PROCEED: 'candidate_pay_book_proceed',
    CANDIDATE_SLOT_BOOKING_DATE_SELECTED: 'candidate_slot_booking_date_selected',
    CANDIDATE_SLOT_BOOKING_TIME_SELECTED: 'candidate_slot_booking_time_selected',
    // Cancellation Events
    CANDIDATE_BOOKING_CONFIRM_REQUEST_CANCELLATION: 'candidate_booking_confirm_request_cancellation',
    CANDIDATE_CANCELLATION_PAGE_RESCHEDULE_CLICK: 'candidate_cancellation_page_reschedule_click',
    CANDIDATE_CANCELLATION_PAGE_PROCEED: 'candidate_cancellation_page_proceed',
    // Lobby Events
    CANDIDATE_LOBBY_WAIT_PAGE_LANDED: 'candidate_lobby_wait_page_landed',
    CANDIDATE_LOBBY_TO_ALMOST_THERE_TRANSITION: 'candidate_lobby_to_almost_there_transition',
    CANDIDATE_ALMOST_THERE_TO_READY_TRANSITION: 'candidate_almost_there_to_ready_transition',
    CANDIDATE_MISSED_SLOT_PAGE_LANDED: 'candidate_missed_slot_page_landed',
    CANDIDATE_BACK_TO_QUEUE_CLICKED: 'candidate_back_to_queue_clicked',
    // Feedback Events
    TASK_TAKER_FEEDBACK_PAGE: 'task_taker_feedback_page',
    FORM_CANDIDATE_LAND_THANK_YOU_PAGE: 'form_candidate_land_thank_you_page',
    CANDIDATE_FEEDBACK_SUBMIT: 'candidate_feedback_submit',
    CANDIDATE_FEEDBACK_SKIP: 'candidate_feedback_skip',
    CANDIDATE_RSVP_PROPOSE_TIME_LAND: 'candidate_rsvp_proposetime_land',
    CANDIDATE_RSVP_PROPOSE_TIME_CONFIRM: 'candidate_rsvp_proposetime_confirm',
    CANDIDATE_RSVP_DECLINE_LAND: 'candidate_rsvp_decline_land',
    CANDIDATE_RSVP_DECLINE_FLOW_PROPOSE_TIME_CLICK: 'candidate_rsvp_declineflow_proposetime_click',
    CANDIDATE_RSVP_DECLINE_CONFIRM: 'candidate_rsvp_decline_confirm',
    CANDIDATE_RSVP_DECLINE_FLOW_PROPOSE_TIME_CONFIRM: 'candidate_rsvp_declineflow_propostime_confirm',
    CANDIDATE_RSVP_DECLINE_FLOW_PROPOSE_TIME_LAND: 'candidate_rsvp_declineflow_proposetime_land',
    CANDIDATE_RSVP_CONFIRM: 'candidate_rsvp_confirm',
    //FaceAuth Events
    CANDIDATE_FACEAUTH_ALLOW: 'candidate_faceauth_allow',
    CANDIDATE_FACEAUTH_BLOCK: 'candidate_faceauth_block',
    CANDIDATE_FACEAUTH_CAPTURE: 'candidate_faceauth_capture',
    CANDIDATE_FACEAUTH_RETAKE: 'candidate_faceauth_retake',
    CANDIDATE_FACEAUTH_SUBMIT: 'candidate_faceauth_submit',
    CANDIDATE_FACEAUTH_NEXTSTEP: 'candidate_faceauth_nextstep',
    //Long Form
    CANDIDATE_LONG_FORM_SUBMIT: 'candidate_long_form_submit',
    CX_PDF_DOWNLOAD_CLICKED: 'cx_pdf_download_clicked',
    CX_PDF_DOWNLOAD_FAILED: 'cx_pdf_download_failed',
    // Running Late Events
    CANDIDATE_RUNNING_LATE_PAGE_LANDED: 'candidate_running_late_page_landed',
    CANDIDATE_RUNNING_LATE_PAGE_CONFIRMED: 'candidate_running_late_page_confirmed',
    // standalone payment events
    USER_STANDALONEPAYMENT_LANDED: 'user_standalonepayment_landed',
    USER_STANDALONEPAYMENT_COUPONCODE_APPLIED: 'user_standalonepayment_couponcode_applied',
    USER_STANDALONEPAYMENT_PROCEED: 'user_standalonepayment_proceed',
    USER_STANDALONEPAYMENT_STATUS: 'user_standalonepayment_status',
    // Custom Instructions Events
    CANDIDATE_CUSTOM_INSTRUCTIONS_VIEWED: 'candidate_custom_instructions_viewed',
    CANDIDATE_CUSTOM_INSTRUCTIONS_CONTINUE_CLICKED: 'candidate_custom_instructions_continue_clicked',
    // Post-Assessment Custom Instructions Events
    CANDIDATE_POST_CUSTOM_INSTRUCTIONS_VIEWED: 'candidate_post_custom_instructions_viewed',
    CANDIDATE_POST_CUSTOM_INSTRUCTIONS_CONTINUE_CLICKED: 'candidate_post_custom_instructions_continue_clicked',
    // question filter events
    CX_MCQ_FILTER_PANEL_OPENED: 'cx_mcq_filter_panel_opened',
    CX_MCQ_FILTER_PANEL_CLOSED: 'cx_mcq_filter_panel_closed',
    CX_MCQ_FILTER_APPLIED: 'cx_mcq_filter_applied',
    CX_MCQ_FILTER_CLEARED: 'cx_mcq_filter_cleared',
    // Live interview availability events (CX-5716) — names/casing match the ticket's Mixpanel spec exactly
    CX_LIVE_INTERVIEW_AVAILABILITY_VIEWED: 'cx_live_interview_availability_viewed',
    CX_LIVE_INTERVIEW_AVAILABILITY_SLOT_SELECTED: 'cx_live_Interview_Availability_Slot_Selected',
    CX_LIVE_INTERVIEW_AVAILABILITY_SUBMITTED: 'cx_live_interview_availability_submitted',
    CX_LIVE_INTERVIEW_AVAILABILITY_SUBMISSION_FAILED: 'cx_live_interview_availability_submission_failed',
};
